export default {
  towStoreDialog: {
    title: 'Expédition de Dépôt de Remorquage',
    description: 'Je vois que vous expédiez un Dépôt de Remorquage (TS). Veuillez ajouter l\'adresse du terrain du fournisseur.',
    addressLabel: 'Adresse',
    addressPlaceholder: 'Entrez l\'adresse du terrain du fournisseur',
    phoneLabel: 'Numéro de Téléphone du Fournisseur',
    phonePlaceholder: '(555) 123-4567',
    submit: 'Soumettre',
    closeAriaLabel: 'fermer',
    addressNotFound: 'Nous n\'avons pas pu trouver d\'adresse Google pour le fournisseur sélectionné. Vous devrez peut-être l\'entrer manuellement.'
  }
};
